import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Logo from "../atoms/logo";
import { FiAlignJustify } from "react-icons/fi";

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const getLinkClass = (path: string) => {
    return location.pathname === path
      ? "text-white font-bold bg-blue-600 rounded-md px-3 py-2"
      : "text-gray-700 hover:bg-blue-500 hover:text-white rounded-md px-3 py-2";
  };

  return (
    <div
      className={`top-0 left-0 w-full p-2 text-gray-700 bg-gray-300 shadow-xl`}
    >
      <div className="container mx-auto">
        <div className="flex items-center justify-between">
          {/* 로고 (필요한 경우 로고를 추가) */}
          <div className="mt-3 max-h-[15vh] max-w-[6vw]">
            <Logo />
          </div>

          {/* PC 화면에서는 네비게이션 메뉴 표시, 모바일에서는 햄버거 메뉴 표시 */}
          <div className="hidden md:flex items-center space-x-4">
            <Link to="/mm">
              <span className={getLinkClass("/mm")}>MM 교육과정 관리</span>
            </Link>
            <Link to="/mmuser">
              <span className={getLinkClass("/mmuser")}>MM 사용자 관리</span>
            </Link>
            <Link to="/sys">
              <span className={getLinkClass("/sys")}>시스템 모니터링</span>
            </Link>
            <Link to="/filesystem">
              <span className={getLinkClass("/filesystem")}>파일 관리</span>
            </Link>
            <Link to="/log">
              <span className={getLinkClass("/log")}>로그</span>
            </Link>
          </div>

          {/* 모바일 화면에서 햄버거 메뉴 아이콘 */}
          <div className="md:hidden">
            <button onClick={toggleMobileMenu}>
              <FiAlignJustify size={25} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
